import type { SxProps, Theme } from '../../../../themes/themes';

export const getStyles = ({ theme }: { theme: Theme }): { [key: string]: SxProps } => {
  return {
    outer: {
      display: 'flex',
      overflowX: 'hidden',
      userSelect: 'none',
    },
    disablePointerEevents: {
      pointerEvents: 'none',
    },
    inner: {
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      paddingInline: theme.spacing(5),
      transform: `translateX(0)`,
      gap: theme.spacing(2),
      [theme.breakpoints.up('lg')]: {
        gap: theme.spacing(3),
      },
    },
    innerAnimated: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.sharp,
        duration: 360,
      }),
    },
  };
};
